import React, { useState } from "react";
import { Container, Row, Col, Card, Form, Button } from "react-bootstrap";
import { Lock, CheckCircle } from "lucide-react";

const Password = ({ email, userPhone, password }) => {
  const [otp, setOtp] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    // Add password reset logic here
    setTimeout(() => setIsLoading(false), 1500);
  };

  return (
    <Card
      style={{
        background: "rgba(255, 255, 255, 0.9)",
        backdropFilter: "blur(20px)",
        border: "1px solid rgba(255, 255, 255, 0.2)",
        borderRadius: "1.5rem",
        boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.1)",
      }}
    >
      <Card.Body className="p-4 p-md-5">
        <div className="text-center mb-4">
          <div
            style={{
              width: "4rem",
              height: "4rem",
              background: "linear-gradient(135deg, #8b5cf6 0%, #a855f7 100%)",
              borderRadius: "1.5rem",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              boxShadow: "0 10px 25px rgba(139, 92, 246, 0.3)",
            }}
          >
            <Lock size={32} className="text-white" />
          </div>
        </div>

        <h2 style={{ textAlign: "center", marginBottom: "2rem", color: "#1e293b" }}>
          Reset Your Password
        </h2>

        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3">
            <Form.Label>OTP</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter OTP sent to your email"
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>New Password</Form.Label>
            <Form.Control
              type="password"
              placeholder="Enter new password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
            />
          </Form.Group>

          <Form.Group className="mb-4">
            <Form.Label>Confirm Password</Form.Label>
            <Form.Control
              type="password"
              placeholder="Confirm your password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
            />
          </Form.Group>

          <Button
            type="submit"
            style={{
              background: "linear-gradient(135deg, #8b5cf6 0%, #a855f7 100%)",
              border: "none",
              borderRadius: "1.5rem",
              padding: "0.75rem 1.5rem",
              fontWeight: 600,
              width: "100%",
            }}
            disabled={isLoading}
          >
            {isLoading ? "Updating..." : "Update Password"}
          </Button>
        </Form>
      </Card.Body>
    </Card>
  );
};

export default Password;
